(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6483],{

/***/ 83046:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/review/[id]",
      function () {
        return __webpack_require__(43774);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 48831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Meta; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Seo_base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47727);
/* harmony import */ var _constants_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7181);





const Meta = (param)=>{
    let { ogImage , noindex , nofollow , additionalMetaTags , title , description , canonical  } = param;
    const ogImages = {
        url: "".concat(_constants_environment__WEBPACK_IMPORTED_MODULE_4__/* .STATIC_DOMAIN */ .xm, "/images/thumb-image.png"),
        width: 720,
        height: 540,
        alt: _components_Seo_base__WEBPACK_IMPORTED_MODULE_3__/* .BaseMetaSeo.metaTitle */ .o.metaTitle
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        charSet: "UTF-8"
                    }, "charset"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1, maximum-scale=1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "shortcut icon",
                        href: "".concat(_constants_environment__WEBPACK_IMPORTED_MODULE_4__/* .STATIC_DOMAIN */ .xm, "/images/favicon.ico")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
                noindex: noindex,
                nofollow: nofollow,
                additionalMetaTags: additionalMetaTags,
                title: title,
                description: description,
                canonical: canonical,
                openGraph: {
                    title: title,
                    description: description,
                    url: canonical,
                    site_name: _components_Seo_base__WEBPACK_IMPORTED_MODULE_3__/* .BaseMetaSeo.siteName */ .o.siteName,
                    images: [
                        ogImage ? ogImage : ogImages
                    ]
                }
            })
        ]
    });
};



/***/ }),

/***/ 47727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ BaseMetaSeo; }
/* harmony export */ });
/* harmony import */ var _constants_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24435);
/* harmony import */ var _constants_environment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7181);
/* harmony import */ var _utils_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77325);



const metaTitle = "Meey Review - Diễn đ\xe0n đ\xe1nh gi\xe1 đa chiều bất động sản dự \xe1n";
const metaDescription = "Minh bạch h\xf3a th\xf4ng tin về c\xe1c dự \xe1n bất động sản th\xf4ng qua đ\xe1nh gi\xe1 đa chiều c\xf3 cơ sở của kh\xe1ch h\xe0ng theo thời gian thực nhằm bảo vệ quyền v\xe0 lợi \xedch của c\xe1c b\xean li\xean quan trong chuỗi ph\xe1t triển bất động sản.";
const metaKeyword = "mua b\xe1n cho thu\xea nh\xe0 đất - bất động sản";
const urlImage = (0,_utils_image__WEBPACK_IMPORTED_MODULE_2__/* .resizeOnFlyUrl */ .Li)({
    uri: _constants_image__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_IMAGE_URI */ .mG,
    width: _constants_image__WEBPACK_IMPORTED_MODULE_0__/* .RESIZE_IMAGE["default"].width */ .$H["default"].width,
    height: _constants_image__WEBPACK_IMPORTED_MODULE_0__/* .RESIZE_IMAGE["default"].height */ .$H["default"].height,
    resizingType: "fill",
    gravity: "no"
});
const baseImage = {
    url: "".concat(_constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .STATIC_DOMAIN */ .xm, "/images/thumb_image.png"),
    description: null,
    name: "capture-meeyhome.jpg",
    mimeType: "image/jpeg",
    width: _constants_image__WEBPACK_IMPORTED_MODULE_0__/* .RESIZE_IMAGE["default"].width */ .$H["default"].width,
    height: _constants_image__WEBPACK_IMPORTED_MODULE_0__/* .RESIZE_IMAGE["default"].height */ .$H["default"].height,
    alt: "Trang chủ"
};
const BaseMetaSeo = {
    baseUrlImage: urlImage,
    metaTitle: metaTitle,
    metaDescription: metaDescription,
    metaKeyword: metaKeyword,
    siteName: _constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .APP_DOMAIN */ .wz,
    locale: "vi_VN",
    canonical: _constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .APP_BASE_URL */ .E5,
    baseImage: baseImage,
    openGraph: {
        title: metaTitle,
        description: metaDescription,
        images: [
            baseImage
        ],
        site_name: _constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .APP_DOMAIN */ .wz,
        locale: "vi_VN",
        url: _constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .APP_BASE_URL */ .E5,
        type: "website",
        article: {
            authors: [
                "https://www.facebook.com/meeyland.global/"
            ]
        }
    },
    facebook: {
        appId: _constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .FB_APP_ID */ .f6
    },
    twitter: {
        site: "@meey_review"
    },
    additionalMetaTags: [
        {
            name: "keywords",
            content: metaKeyword !== null && metaKeyword !== void 0 ? metaKeyword : ""
        },
        {
            property: "fb:pages",
            content: "148873268971895"
        },
        {
            property: "article:author",
            content: "https://www.facebook.com/meeyland.global/"
        },
        {
            property: "twitter:creator",
            content: "@meey_review"
        },
        {
            property: "twitter:title",
            content: metaTitle || ""
        },
        {
            property: "twitter:description",
            content: metaDescription || ""
        },
        {
            property: "twitter:image",
            content: urlImage
        },
        {
            property: "twitter:image:width",
            content: "".concat(_constants_image__WEBPACK_IMPORTED_MODULE_0__/* .RESIZE_IMAGE["default"].width */ .$H["default"].width)
        },
        {
            property: "twitter:image:height",
            content: "".concat(_constants_image__WEBPACK_IMPORTED_MODULE_0__/* .RESIZE_IMAGE["default"].height */ .$H["default"].height)
        },
        {
            property: "og:locale:alternate",
            content: "vi_VN"
        }
    ],
    siteLinkSearchBox: {
        type: "Website",
        name: "Meey Review",
        url: _constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .APP_BASE_URL */ .E5
    }
};


/***/ }),

/***/ 43774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ Review; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40364);
/* harmony import */ var _components_Seo_Meta__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48831);
/* harmony import */ var _constants_environment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7181);
/* harmony import */ var _constants_file__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32336);
/* harmony import */ var _constants_project_constant__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18825);
/* harmony import */ var _context_device_context__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99757);
/* harmony import */ var _context_project_context__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12482);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67650);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(67294);












const ReviewDetail = next_dynamic__WEBPACK_IMPORTED_MODULE_9___default()(()=>Promise.all(/* import() */[__webpack_require__.e(2544), __webpack_require__.e(4824), __webpack_require__.e(314), __webpack_require__.e(9510), __webpack_require__.e(5620), __webpack_require__.e(1590), __webpack_require__.e(1696), __webpack_require__.e(4749), __webpack_require__.e(7043), __webpack_require__.e(5214), __webpack_require__.e(5315), __webpack_require__.e(6289), __webpack_require__.e(8343), __webpack_require__.e(1800), __webpack_require__.e(7436), __webpack_require__.e(3216)]).then(__webpack_require__.bind(__webpack_require__, 3009)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(3009)
            ]
    }
});
const ReviewDetailMobile = next_dynamic__WEBPACK_IMPORTED_MODULE_9___default()(()=>Promise.all(/* import() */[__webpack_require__.e(2544), __webpack_require__.e(4824), __webpack_require__.e(314), __webpack_require__.e(9510), __webpack_require__.e(5620), __webpack_require__.e(1590), __webpack_require__.e(1696), __webpack_require__.e(4749), __webpack_require__.e(5214), __webpack_require__.e(6289), __webpack_require__.e(8343), __webpack_require__.e(7436), __webpack_require__.e(8847)]).then(__webpack_require__.bind(__webpack_require__, 18847)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18847)
            ]
    }
});
var __N_SSP = true;
function Review(props) {
    var _props_project, _props_reviewDetail;
    const { isMobile  } = (0,react__WEBPACK_IMPORTED_MODULE_11__.useContext)(_context_device_context__WEBPACK_IMPORTED_MODULE_6__/* .DeviceContext */ .T);
    const ogImage = (0,react__WEBPACK_IMPORTED_MODULE_11__.useMemo)(()=>{
        var _props_reviewDetail__media, _props_reviewDetail, _props_reviewDetail__createdBy, _props_reviewDetail1, _props_reviewDetail2, _props_project, _props_project_logo;
        const existImage = (_props_reviewDetail__media = (_props_reviewDetail = props.reviewDetail) === null || _props_reviewDetail === void 0 ? void 0 : _props_reviewDetail[0].media) === null || _props_reviewDetail__media === void 0 ? void 0 : _props_reviewDetail__media.find((e)=>{
            var _e_name_match;
            return (_e_name_match = e.name.match(_constants_file__WEBPACK_IMPORTED_MODULE_4__/* .fileType.image */ .r.image)) === null || _e_name_match === void 0 ? void 0 : _e_name_match.length;
        });
        if (existImage) return (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .resizeOnFlyUrl */ .Li)({
            resizingType: "fill",
            gravity: "ce",
            width: 404,
            height: 270,
            uri: existImage.uri
        });
        else return ((_props_reviewDetail__createdBy = (_props_reviewDetail1 = props.reviewDetail) === null || _props_reviewDetail1 === void 0 ? void 0 : _props_reviewDetail1[0].createdBy) === null || _props_reviewDetail__createdBy === void 0 ? void 0 : _props_reviewDetail__createdBy.avatar) ? (_props_reviewDetail2 = props.reviewDetail) === null || _props_reviewDetail2 === void 0 ? void 0 : _props_reviewDetail2[0].createdBy.avatar : ((_props_project = props.project) === null || _props_project === void 0 ? void 0 : (_props_project_logo = _props_project.logo) === null || _props_project_logo === void 0 ? void 0 : _props_project_logo.uri) ? (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .resizeOnFlyUrl */ .Li)({
            resizingType: "fill",
            gravity: "ce",
            width: 600,
            height: 315,
            uri: props.project.logo.uri
        }) : _constants_environment__WEBPACK_IMPORTED_MODULE_3__/* .STATIC_DOMAIN */ .xm + "/" + _constants_project_constant__WEBPACK_IMPORTED_MODULE_5__/* .DEFAULT_LOGO_PROJECT */ .J3;
    }, [
        props
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: ((_props_project = props.project) === null || _props_project === void 0 ? void 0 : _props_project._id) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_context_project_context__WEBPACK_IMPORTED_MODULE_7__/* .ProjectContextProvider */ .M, {
            project: props.project,
            reviewDetail: props.reviewDetail,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Seo_Meta__WEBPACK_IMPORTED_MODULE_2__/* .Meta */ .h, {
                    title: props.project.title,
                    description: (_props_reviewDetail = props.reviewDetail) === null || _props_reviewDetail === void 0 ? void 0 : _props_reviewDetail[0].comment,
                    ogImage: {
                        width: 600,
                        height: 315,
                        url: ogImage,
                        alt: props.project.title
                    }
                }),
                isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReviewDetailMobile, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReviewDetail, {})
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "w-screen h-[100vh] gap-8 flex items-center justify-center flex-col",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    children: "Kh\xf4ng t\xecm thấy dự \xe1n"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_10___default()), {
                    href: "/",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        btnType: "filled",
                        children: "Về trang chủ"
                    })
                })
            ]
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5051,5646,8758,9774,2888,179], function() { return __webpack_exec__(83046); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);